import React, { useMemo } from 'react';
import LowerFooter from '../Components/LowerFooter';
import './Contact.css';
import { useLocale } from '../context/LocaleContext';
import { translate } from '../i18n/translations';

const Contact = () => {
  const { locale, t } = useLocale();

  const clinic_data = useMemo(
    () => translate(locale, 'contact.days'),
    [locale]
  );

  return (
    <>
      <div className="contact_section_container" id="contact-us">
        <div className="container_container">
          <div className="google_map_location">
            <div className="gmap">
              <iframe
                title="gmap_location"
                className="gmap_iframe"
                width="100%"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2494.2481953242086!2d-71.96398252281416!3d-13.522669105093586!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x916dd5fd6e89d925%3A0x5028062beeb7ea6f!2sClinica%20Dental%20Smile%20Up%20%7C%20Ortodoncia%20%2C%20Implante%2C%20Odontopediatria.!5e0!3m2!1ses-419!2spe!4v1769210347450!5m2!1ses-419!2spe"
              ></iframe>
            </div>
          </div>
          <div className="basic_contact_user_form">
            <div className="clinic_time_table">
              <h2>
                <span>
                  <i className="fa-solid fa-angles-right"></i>
                </span>
                {t('contact.scheduleTitle')}
              </h2>
            </div>
            <hr />
            {clinic_data.map((e, index) => (
              <div className="clinic_timing" key={index}>
                <p className="current_day">{e.day}</p>
                <p className="current_day_timing">{e.time}</p>
              </div>
            ))}
            <div className="contact_schedule_actions">
              <a
                className="contact_schedule_btn contact_schedule_btn--maps"
                href="https://maps.app.goo.gl/ZcuCg67p7StV3LBU7"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-solid fa-location-dot" aria-hidden="true" />
                <span>{t('contact.directions')}</span>
              </a>
              <a className="contact_schedule_btn contact_schedule_btn--call" href="tel:+51984403369">
                <i className="fa-solid fa-phone" aria-hidden="true" />
                <span>{t('contact.callClinic')}</span>
              </a>
            </div>
          </div>
        </div>
        <LowerFooter />
      </div>
    </>
  );
};

export default Contact;
